var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = { style: { "display": "block" } };
var _hoisted_2 = { class: "flex items-center text-lg" };
var _hoisted_3 = { style: { "display": "block" } };
var _hoisted_4 = { class: "bg-white dark:bg-gray-900" };
var _hoisted_5 = { class: "py-8 px-4 mx-auto max-w-2xl lg:py-32" };
var _hoisted_6 = { action: "#" };
var _hoisted_7 = {
    class: "grid gap-4 sm:grid-cols-2 sm:gap-6",
    style: { "margin-top": "-25px" }
};
var _hoisted_8 = { class: "sm:col-span-2" };
var _hoisted_9 = {
    for: "name",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_10 = {
    role: "status",
    style: { "display": "inline-block", "margin-left": "2%" }
};
var _hoisted_11 = ["aria-hidden"];
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
}, null, -1);
var _hoisted_13 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
}, null, -1);
var _hoisted_14 = [
    _hoisted_12,
    _hoisted_13
];
var _hoisted_15 = /*#__PURE__*/ _createElementVNode("span", { class: "sr-only" }, "Loading...", -1);
var _hoisted_16 = { class: "relative" };
var _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        "aria-hidden": "true",
        class: "w-5 h-5 text-gray-500 dark:text-gray-400",
        fill: "currentColor",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        id: "search"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
    ])
], -1);
var _hoisted_18 = ["placeholder"];
var _hoisted_19 = ["selected", "value"];
var _hoisted_20 = { class: "text-red-500 text-sm mb-0 w-full" };
var _hoisted_21 = {
    key: 0,
    class: "flex mt-2"
};
var _hoisted_22 = { class: "w-1/3 mr-2" };
var _hoisted_23 = {
    id: "forma",
    for: "forma",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_24 = ["value"];
var _hoisted_25 = {
    key: 0,
    class: "w-2/3 flex"
};
var _hoisted_26 = { class: "w-1/2 mr-2" };
var _hoisted_27 = {
    for: "quantita",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_28 = { class: "text-red-500 text-sm mb-0 w-full" };
var _hoisted_29 = { class: "w-1/2" };
var _hoisted_30 = {
    for: "frequenza",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_31 = { class: "text-red-500 text-sm mb-0 w-full" };
var _hoisted_32 = { class: "flex mt-2" };
var _hoisted_33 = { class: "w-1/2 mr-2" };
var _hoisted_34 = {
    for: "start_date",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_35 = { class: "text-red-500 text-sm mb-0 w-full" };
var _hoisted_36 = {
    key: 0,
    class: "w-1/2"
};
var _hoisted_37 = {
    for: "end_date",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_38 = { key: 0 };
var _hoisted_39 = { class: "text-red-500 text-sm mb-0 w-full" };
var _hoisted_40 = { key: 0 };
var _hoisted_41 = {
    key: 1,
    class: "w-full mt-2 mr-2"
};
var _hoisted_42 = {
    for: "diagnosi",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_43 = { value: "" };
var _hoisted_44 = ["value"];
var _hoisted_45 = {
    value: "0",
    style: { "font-style": "italic", "background-color": "#1a576e", "color": "white" }
};
var _hoisted_46 = { class: "flex mt-2" };
var _hoisted_47 = { class: "w-1/2 mr-2" };
var _hoisted_48 = {
    for: "careprovider",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_49 = {
    value: "",
    selected: "",
    disabled: "",
    hidden: ""
};
var _hoisted_50 = ["value"];
var _hoisted_51 = {
    value: "0",
    style: { "font-style": "italic", "background-color": "#1a576e", "color": "white" }
};
var _hoisted_52 = { class: "text-red-500 text-sm mb-0 w-full" };
var _hoisted_53 = { class: "w-1/2" };
var _hoisted_54 = {
    for: "confidenzialità",
    class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_55 = ["value"];
var _hoisted_56 = { class: "w-full mb-2" };
var _hoisted_57 = {
    for: "note",
    class: "block mt-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_58 = { key: 0 };
var _hoisted_59 = { key: 1 };
var _hoisted_60 = {
    key: 0,
    class: "text-red-500 text-sm mb-0 w-full"
};
var _hoisted_61 = {
    key: 1,
    class: "text-red-500 text-sm mb-0 w-full"
};
var _hoisted_62 = { class: "flex justify-between mt-2" };
import { filterFarmaci } from "@/../../EshJSLib/services/farmaciServices";
import { onMounted, reactive } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import { useRouter } from "vue-router";
import { compareDates } from "@/../../EshJSLib/services/relatedFunction";
import { checkInterazioniFarmaco } from '@/../../EshJSLib/services/farmaciServices';
export default /*#__PURE__*/ _defineComponent({
    __name: 'farmaciAggiuntiveEdit',
    emits: ["cancel"],
    setup: function (__props, _a) {
        var __expose = _a.expose, emit = _a.emit;
        var alertModal = ref(null);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var farmacoSrc = ref(false);
        var terapienew = ref({});
        var alertConfirmMessage = ref(null);
        var showConfirm = ref(false);
        var farmacoSearch = ref("");
        var resolvePromise;
        var isOpen = ref(false);
        var filteredFarmaci = {};
        var selectedarmaco = {};
        var filteredFarmaciReact = reactive(filteredFarmaci);
        var errors = ref([]);
        var errorMessage = "Questo campo è obbligatorio!";
        var dateError = ref('');
        var errorsNote = ref('');
        onMounted(function () {
            errors.value = [];
            initFlowbite();
        });
        var router = useRouter();
        var handleDiagnosiChange = function () {
            if (terapienew.value.id_diagnosi === 0) {
                router.push('/Registro/Diagnosi');
            }
        };
        var handleCareproviderChange = function () {
            if (terapienew.value.id_prescrittore == 0) {
                router.push('/Registro/Dottori');
            }
        };
        function checkDrugInteraction(idFarmaco) {
            return __awaiter(this, void 0, Promise, function () {
                var result, messaggi, confirmed, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            farmacoSrc.value = true;
                            return [4 /*yield*/, checkInterazioniFarmaco(idFarmaco)];
                        case 1:
                            result = _a.sent();
                            if (result.esito && result.messaggiInterazioni.length > 0) {
                                messaggi = result.messaggiInterazioni
                                    .map(function (interazione) { return "\u26A0\uFE0F ".concat(interazione.farmaco_in_corso, " \u2194 ").concat(interazione.interazione_con); })
                                    .join('\n');
                                confirmed = confirm("Attenzione: interazione tra farmaci!\n\n".concat(messaggi, "\n\nVuoi continuare comunque?"));
                                return [2 /*return*/, confirmed];
                            }
                            return [2 /*return*/, true]; // nessuna interazione, procedi
                        case 2:
                            error_1 = _a.sent();
                            console.error("Errore nel controllo interazioni:", error_1);
                            alert("Errore nel controllo delle interazioni tra farmaci.");
                            return [2 /*return*/, false];
                        case 3:
                            farmacoSrc.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        function openModal(message, rowData) {
            var _a;
            errors.value = [];
            errorsNote.value = "";
            terapienew.value = rowData;
            alertConfirmMessage.value = message;
            showConfirm.value = true;
            farmacoSearch.value = (_a = rowData.farmaco) === null || _a === void 0 ? void 0 : _a.descrizione_breve;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function validateDates() {
            if (!compareDates(terapienew.value.data_inizio, terapienew.value.data_fine)) {
                terapienew.value.data_fine = terapienew.value.data_inizio;
                dateError.value = "Per favore, inserisci date valide. La data di fine terapia non può essere maggiore della data d'inizio!";
            }
            else {
                dateError.value = '';
            }
        }
        function validateFields() {
            var hasError = false;
            errors.value = Array(7).fill(""); // Assicura che l'array di errori abbia la giusta lunghezza e venga ripulito
            // Controllo campi obbligatori in base al tipo di terapia
            var fieldsToCheck = [];
            switch (terapienew.value.tipo_terapia) {
                // Farmaci Vietati
                case '0':
                    fieldsToCheck = ['id_farmaco_codifa', 'id_prescrittore', 'data_inizio', 'note'];
                    break;
                // Terapie in Corso
                case '1':
                    fieldsToCheck = ['id_farmaco_codifa', 'id_prescrittore', 'quantita_farmaceutica', 'frequenza_farmaceutica', 'data_inizio'];
                    break;
                // Terapie Concluse
                case '2':
                    fieldsToCheck = ['id_farmaco_codifa', 'id_prescrittore', 'quantita_farmaceutica', 'frequenza_farmaceutica', 'data_inizio', 'data_fine'];
                    break;
            }
            fieldsToCheck.forEach(function (field, index) {
                if (!terapienew.value[field]) {
                    hasError = true;
                    errors.value[index] = "Questo campo è obbligatorio!";
                }
            });
            // Controllo specifico per `data_inizio`
            if (!terapienew.value.data_inizio) {
                errors.value[4] = "La data di inizio è obbligatoria!";
                hasError = true;
            }
            // Controllo sulla lunghezza della nota
            if (terapienew.value.note && terapienew.value.note.length > 100) {
                errorsNote.value = 'La nota non può superare i 100 caratteri.';
            }
            else {
                errorsNote.value = "";
            }
            // Controllo se la data di fine è valida
            if (terapienew.value.data_fine && new Date(terapienew.value.data_inizio) > new Date(terapienew.value.data_fine)) {
                dateError.value = "Data di fine non può essere precedente alla data di inizio!";
                hasError = true;
            }
            else {
                dateError.value = "";
            }
            // Se terapia vietata, assicuriamoci che il motivo sia obbligatorio
            if (terapienew.value.tipo_terapia === '0' && !terapienew.value.note) {
                errors.value[6] = "Il motivo è obbligatorio per le terapie vietate";
                hasError = true;
            }
            return !hasError;
        }
        function saveFarmaci() {
            terapienew.value.farmaco = selectedarmaco;
            if (!validateFields()) {
                return;
            }
            alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then(function (userInput) {
                if (userInput) {
                    showConfirm.value = false;
                    if (!resolvePromise)
                        return;
                    resolvePromise(true);
                }
            });
        }
        function closeModal() {
            showConfirm.value = false;
            if (!resolvePromise)
                return;
            resolvePromise(false);
            emit("cancel");
        }
        function onFarmacoChange(e) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var id, name, confirmed;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            isOpen.value = false;
                            if (!e.target)
                                return [2 /*return*/];
                            id = e.target.value;
                            name = e.target.options[e.target.options.selectedIndex].text;
                            farmacoSearch.value = name;
                            selectedarmaco = (_b = (_a = filteredFarmaciReact === null || filteredFarmaciReact === void 0 ? void 0 : filteredFarmaciReact.Farmaci) === null || _a === void 0 ? void 0 : _a.at(e.target.options.selectedIndex)) !== null && _b !== void 0 ? _b : null;
                            terapienew.value.id_farmaco_codifa = id;
                            return [4 /*yield*/, checkDrugInteraction(id)];
                        case 1:
                            confirmed = _c.sent();
                            if (!confirmed) {
                                terapienew.value.id_farmaco_codifa = null;
                                farmacoSearch.value = "";
                                selectedarmaco = {};
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function filtername() {
            farmacoSrc.value = true;
            filteredFarmaci = {};
            if (farmacoSearch.value.length < 2) {
                farmacoSrc.value = false;
                return;
            }
            var res = filterFarmaci(farmacoSearch.value);
            res.then(function (value) {
                filteredFarmaciReact.Farmaci = value;
                isOpen.value = true;
                farmacoSrc.value = false;
            });
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    onClose: _cache[14] || (_cache[14] = function ($event) { return (closeModal()); }),
                    style: { "max-height": "80%" }
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
                        ])
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("section", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("form", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Farmaco")) + " * ", 1),
                                                _withDirectives(_createElementVNode("div", _hoisted_10, [
                                                    (_openBlock(), _createElementBlock("svg", {
                                                        "aria-hidden": !_unref(farmacoSrc),
                                                        class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                                                        viewBox: "0 0 100 101",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg"
                                                    }, _hoisted_14, 8, _hoisted_11)),
                                                    _hoisted_15
                                                ], 512), [
                                                    [_vShow, _unref(farmacoSrc)]
                                                ]),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _hoisted_17,
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        id: "farmaco",
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((farmacoSearch).value = $event); }),
                                                        onKeyup: filtername,
                                                        onClick: _cache[1] || (_cache[1] = function ($event) { return (_isRef(isOpen) //@ts-ignore
                                                            ? isOpen.value = true : isOpen = true); }),
                                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                        placeholder: _ctx.$t('Cerca farmaco')
                                                    }, null, 40, _hoisted_18), [
                                                        [_vModelText, farmacoSearch.value]
                                                    ])
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    id: "farmacoSelect",
                                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                                    onChange: _cache[2] || (_cache[2] = function ($event) { return (onFarmacoChange($event)); }),
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_unref(terapienew).id_farmaco_codifa) = $event); }),
                                                    size: "3"
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFarmaciReact.Farmaci, function (item) {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            selected: item.id_farmaco_codifa === __spreadArray([], filteredFarmaciReact.Farmaci, true)[0].id_farmaco_codifa,
                                                            key: item.id_farmaco_codifa,
                                                            value: item.id_farmaco_codifa
                                                        }, _toDisplayString(item.descrizione_breve), 9, _hoisted_19));
                                                    }), 128))
                                                ], 34), [
                                                    [_vShow, _unref(isOpen) === true],
                                                    [_vModelSelect, _unref(terapienew).id_farmaco_codifa]
                                                ]),
                                                _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(errors)[0]), 1)
                                            ]),
                                            (_unref(terapienew).tipo_terapia != '0')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("Forma")), 1),
                                                        _createElementVNode("input", {
                                                            type: "text",
                                                            disabled: "",
                                                            value: _unref(selectedarmaco).somministrazione,
                                                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                        }, null, 8, _hoisted_24)
                                                    ]),
                                                    (_unref(terapienew).tipo_terapia != '0')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                            _createElementVNode("div", _hoisted_26, [
                                                                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("Dose")) + " * ", 1),
                                                                _withDirectives(_createElementVNode("input", {
                                                                    id: "dose",
                                                                    type: "text",
                                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((_unref(terapienew).quantita_farmaceutica) = $event); }),
                                                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[2] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                                                                }, null, 2), [
                                                                    [_vModelText, _unref(terapienew).quantita_farmaceutica]
                                                                ]),
                                                                _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(errors)[2]), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_29, [
                                                                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("Frequenza")) + " * ", 1),
                                                                _withDirectives(_createElementVNode("input", {
                                                                    id: "frequenza",
                                                                    type: "text",
                                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((_unref(terapienew).frequenza_farmaceutica) = $event); }),
                                                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[3] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                                                                }, null, 2), [
                                                                    [_vModelText, _unref(terapienew).frequenza_farmaceutica]
                                                                ]),
                                                                _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(errors)[3]), 1)
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(terapienew).tipo_terapia === '0' ? _ctx.$t("Data *") : _ctx.$t("Data inizio") + " *"), 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "date",
                                                        id: "start_date",
                                                        name: "start_date",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((_unref(terapienew).data_inizio) = $event); }),
                                                        class: _normalizeClass([{ 'border-red-500': _unref(errors)[4] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                                                    }, null, 2), [
                                                        [_vModelText, _unref(terapienew).data_inizio]
                                                    ]),
                                                    _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(errors)[4]), 1)
                                                ]),
                                                (_unref(terapienew).tipo_terapia != '0')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                        _createElementVNode("label", _hoisted_37, [
                                                            _createTextVNode(_toDisplayString(_ctx.$t("Data fine")), 1),
                                                            (_unref(terapienew).tipo_terapia === '2')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " *"))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "date",
                                                            onChange: validateDates,
                                                            id: "end_date",
                                                            name: "end_date",
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((_unref(terapienew).data_fine) = $event); }),
                                                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                        }, null, 544), [
                                                            [_vModelText, _unref(terapienew).data_fine]
                                                        ]),
                                                        _createElementVNode("p", _hoisted_39, [
                                                            _createTextVNode(_toDisplayString(_unref(dateError)) + " ", 1),
                                                            (_unref(terapienew).tipo_terapia === '2')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(errors)[5]), 1))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            (_unref(terapienew).tipo_terapia != '0')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("Diagnosi")), 1),
                                                    _withDirectives(_createElementVNode("select", {
                                                        onChange: handleDiagnosiChange,
                                                        id: "diagnosi",
                                                        name: "diagnosi",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((_unref(terapienew).id_diagnosi) = $event); }),
                                                        class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                    }, [
                                                        _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("Nessuna diagnosi")), 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).diagnosi, function (item) {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: item.id_diagnosi,
                                                                value: item.id_diagnosi
                                                            }, _toDisplayString(item.diagnosi_patologia), 9, _hoisted_44));
                                                        }), 128)),
                                                        _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t("Aggiungere nuova diagnosi")), 1)
                                                    ], 544), [
                                                        [_vModelSelect, _unref(terapienew).id_diagnosi]
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("div", _hoisted_47, [
                                                    _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(terapienew).tipo_terapia === '0' ? _ctx.$t("Medico *") : _ctx.$t("Prescrittore") + " *"), 1),
                                                    _withDirectives(_createElementVNode("select", {
                                                        onChange: handleCareproviderChange,
                                                        id: "careprovider",
                                                        name: "careprovider",
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((_unref(terapienew).id_prescrittore) = $event); }),
                                                        class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                                                    }, [
                                                        _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t("Selezionare un Professionista Sanitario")) + "... ", 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).associated_doctors, function (item) {
                                                            var _a;
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: item.id_utente,
                                                                value: item.id_utente
                                                            }, _toDisplayString((_a = item.care_provider) === null || _a === void 0 ? void 0 : _a.fullname), 9, _hoisted_50));
                                                        }), 128)),
                                                        _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.$t("Aggiungere nuovo careprovider")), 1)
                                                    ], 34), [
                                                        [_vModelSelect, _unref(terapienew).id_prescrittore]
                                                    ]),
                                                    _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(errors)[1]), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_53, [
                                                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("Livello di confidenzialità")) + " * ", 1),
                                                    _withDirectives(_createElementVNode("select", {
                                                        id: "confidenzialità",
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((_unref(terapienew).id_livello_confidenzialita) = $event); }),
                                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, function (item, key) {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: item.id_livello_confidenzialita,
                                                                key: key
                                                            }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_55));
                                                        }), 128))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(terapienew).id_livello_confidenzialita]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_56, [
                                                _createElementVNode("label", _hoisted_57, [
                                                    (_unref(terapienew).tipo_terapia != '0')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.$t("Note")), 1))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.$t("Motivo")) + " *", 1))
                                                ]),
                                                _withDirectives(_createElementVNode("textarea", {
                                                    id: "note",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((_unref(terapienew).note) = $event); }),
                                                    class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                }, "\n                  ", 512), [
                                                    [_vModelText, _unref(terapienew).note]
                                                ]),
                                                (_unref(terapienew).tipo_terapia === '0')
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(_unref(errors)[6]), 1))
                                                    : _createCommentVNode("", true),
                                                (_unref(errorsNote))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_unref(errorsNote)), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("button", {
                                    onClick: _cache[12] || (_cache[12] = function ($event) { return (closeModal()); }),
                                    type: "button",
                                    class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                                }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                _createElementVNode("button", {
                                    id: "submit",
                                    onClick: _cache[13] || (_cache[13] = function ($event) { return (saveFarmaci()); }),
                                    type: "button",
                                    class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                }, _toDisplayString(_ctx.$t("Salva")), 1)
                            ]),
                            _createVNode(AlertModal, {
                                ref_key: "alertModal",
                                ref: alertModal
                            }, null, 512)
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
